<div fxLayout="column" fxLayoutGap="20px" class="connect-start-container">
  <section fxLayout fxLayoutGap="10px">
    <sbnb-icon-agoda fxHide.lt-md [size]="30"></sbnb-icon-agoda>
    <h2 class="nomargin">Connecting {{ 'CORE.PRODUCT_NAME' | transloco }} with Agoda</h2>
  </section>

  <section>
    <p>
      Save time emailing updates to your Agoda guests with our automated, AI-powered messaging rules. You can keep
      pricing and availability synchronized across multiple channels and avoid double bookings by managing all your
      reservations in one place.
    </p>

    <p>Connecting your account is a secure and straightforward way to make the most of your Hospitable subscription.</p>
  </section>

  <section>
    <div
      fxLayout
      fxLayoutGap="18px"
      fxLayoutAlign="end center"
      fxLayout.lt-md="column"
      fxLayoutAlign.lt-md="center stretch">
      <button
        id="connect-credentials-cancel"
        mat-flat-button
        fxFlexOrder.lt-md="99"
        class="button__secondary"
        [routerLink]="['/accounts']">
        Cancel
      </button>
      <button id="connect-credentials-primary" mat-flat-button (click)="stepComplete.emit()">Continue</button>
    </div>
  </section>
</div>
